/**
 * Karten-/Katalogpositionen sind zu ~95 % Einzelgerichte (Preis PRO GAST). Ausnahme: Platten,
 * Bretter und "fuer N Personen"-Sets — die sind EIN Artikel, der mehrere Gaeste versorgt, und
 * duerfen NICHT mit der Gaestezahl multipliziert werden (per_piece / "pro Stueck").
 *
 * Herkunft: urspruenglich nur im Speisekarten-Import (`apps/api/src/lib/menu-parse.ts`,
 * `guessPricingUnit`) — dort greift die Erkennung beim automatischen Uebernehmen einer Karte.
 * Bug (STORIA, Mimmo, 07./08.09.2026): manuell im Katalog angelegte Positionen sowie Positionen,
 * deren Namen erst NACHTRAEGLICH im Angebot um "fuer N Personen" ergaenzt wurden, durchliefen
 * diese Erkennung nie und blieben auf dem harten Default `per_person` haengen — bei 40 Gaesten
 * wurde eine eingetragene Stueckzahl "3" (bzw. "8") faelschlich zu 120 (bzw. 320) hochgerechnet.
 * Diese Datei ist die gemeinsame Quelle fuer BEIDE Staende — Katalogpflege (`apps/web`, neue
 * Position + Warnhinweis bei bestehenden Positionen) und Speisekarten-Import (`apps/api`) —
 * damit die Erkennung nicht mehr an einer der beiden Stellen fehlt.
 */

// Ohne Wortgrenzen: deutsche Komposita ("Kaeseplatte", "Vorspeisenplatte", "Wurstbrett").
const PLATTER_RE = /(platte|plateau|etag[eè]re|brett|board|tablett|gedeck|sharing)/i;
// "fuer 6 Personen", "(4 Pers.)", "à 8 Gaeste", "6-Personen" — Zahl direkt vor Personen-Wort.
const PER_N_PERSONS_RE = /\d+\s*(?:-\s*)?(?:personen|pers\b|gäste|gaeste|leute)/i;

/** true, wenn Name/Beschreibung auf eine Portionsgroesse (Platte/"fuer N Personen") hindeuten. */
export function klingtNachPortionsgroesse(name: string, description?: string | null): boolean {
  const hay = `${name} ${description ?? ""}`;
  return PLATTER_RE.test(hay) || PER_N_PERSONS_RE.test(hay);
}

/**
 * Raet den Preistyp einer Position aus Name + Beschreibung.
 * Platten/Bretter/"fuer N Personen" -> per_piece (nicht × Gaestezahl), sonst per_person.
 * Rein heuristisch; der Mensch kann jederzeit umstellen (Katalog-Drawer, ItemRow `cycleMode`).
 */
export function guessPricingUnit(name: string, description?: string | null): "per_person" | "per_piece" {
  return klingtNachPortionsgroesse(name, description) ? "per_piece" : "per_person";
}
